import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-time-roll-apprve-form',
  templateUrl: './time-roll-apprve-form.component.html',
  styleUrls: ['./time-roll-apprve-form.component.css']
})
export class TimeRollApprveFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Attendance-Leaves/time-roll-approval/time-roll-apprve-form/time-roll-apprve-form.component.ts